// extracted by mini-css-extract-plugin
export default {"container":"aO-z","topReviewHeading":"bO-z","criticalReview":"cO-z","favorableReview":"dO-z","vsSeparator":"eO-z"};